import React from "react";
import { useOutlet } from "react-router-dom";
const GlobalLayout = () => {
  const outlet = useOutlet();
  return <React.Fragment>{outlet}</React.Fragment>;
};

export default GlobalLayout;
